export type ViewboxGdprCompany = {
  id: number;
  name: string;
  type: string;
};

export type ActionKind = 'removal' | 'change';

export type ViewboxGdprData = {
  candidateId: number;
  candidateName: string;
  companyName: string;
  language: string;
};

export type ViewboxConsentRequestData = ViewboxGdprData & {
  consentPrivacyLink?: string;
  extensionDays: number;
  candidateToken: string;
  isPreview?: boolean;
};

export type ViewboxRequestBody = {
  kind: ActionKind;
  message: string;
};

export enum ViewboxConsentRequestActions {
  Accept = 'accept',
  Decline = 'decline',
  Confirm = 'confirm',
}
